import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, UrlSerializer } from '@angular/router';
import { EsaBuildPart } from './esa-build-part';

@Injectable()
export class UrlBuilder {
    constructor(private readonly router: Router,
                private readonly location: Location,
                private readonly urlSerializer: UrlSerializer) { }

    public esa(): EsaBuildPart {
        return new EsaBuildPart({router: this.router, location: this.location, urlSerializer: this.urlSerializer});
    }
}